<template>
    <div>
        <h1>PageNotFound</h1>
        <iu-button @click="linkToSchedule">Manage my schedule</iu-button>
    </div>
</template>

<script>
export default {
    methods: {
        linkToSchedule() {
            this.$router.push({
                name: 'Schedule',
            });
        },
    },
};
</script>

<style lang="scss" scope>
h1 {
    margin: 20px;
}
</style>
